import { $qs, $qsa } from './utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function teamGlobe() {

    const globe = $qs('[data-name="team-globe"]');
    const contain = $qs('[data-name="team-globe-contain"]');
    const shapes = $qsa('[data-name="team-globe-shapes"] > *');
    if (!globe) return;


const bounds = globe.getBBox();

const center = {
  x: bounds.x + bounds.width  / 2,
  y: bounds.y + bounds.height / 2,
};

// console.info(center);

let stagger = 1;
var radius = getDistance(center, bounds);

let tl = new gsap.timeline({
  ease: 'none',
  scrollTrigger: {
      trigger: globe,
      pin: globe,
      start: 'top 20%',
      end: '90%',
      scrub: true,
      // markers: true
  },
});





[...shapes].forEach((shape) => {

  const bbox = shape.getBBox();
  const dist = getDistance(bbox, center);
  // const delay = dist / radius * stagger;  
  const scalar = radius / dist;

  tl.from(shape, {
    duration: 5,
    // autoAlpha: 0,
    x: (bbox.x - center.x) * scalar, 
    y: (bbox.y - center.y) * scalar
  }, 'start');  

});

tl.to(contain, {opacity: 0, duration: 3.4});

  
}

function getDistance(p1, p2) {
    var dx = p2.x - p1.x;
    var dy = p2.y - p1.y;
    return Math.sqrt(dx * dx + dy * dy);
  }


export default teamGlobe;